// extracted by mini-css-extract-plugin
module.exports = {"ellipse":"Ellipse_ellipse__QdT1d"};